export default [
  {
    resource: "administration",
    header: "Serveis",
  },
  {
    action: "manage",
    resource: "all",
    title: "Genèrics",
    route: "foravila-global-services-list",
    icon: "GlobeIcon",
  },
  {
    action: "manage",
    resource: "administration",
    title: "Transfers",
    route: "foravila-transfers-list",
    icon: "TruckIcon",
  },
];
